<template>
  <vl-region>
    <vl-layout>
      <LatestPublicationsDatatable></LatestPublicationsDatatable>
    </vl-layout>
  </vl-region>
</template>
<script lang="ts" setup>
import { watch } from 'vue';
import { useRoute } from 'vue-router';
import LatestPublicationsDatatable from './subcomponents/latest-publications-datatable/LatestPublicationsDatatable.vue';
import { rememberOverview } from '@/modules/publications/common';

const route = useRoute();

// Every state of this page, so that the link back from a publication returns to the filter and the
// page the reader left behind. Watched rather than set once: the filter rewrites the URL as it goes.
watch(() => route.fullPath, rememberOverview, { immediate: true });
</script>

<style lang="scss" scoped></style>
